import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UserModel } from '../models/user.model';
import { NbAuthService, NbAuthResult, NbAuthJWTToken } from '@nebular/auth';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RolModel } from '../models/rol.model';
import { ResposeInfoModel } from '../models/response-info.model';
import { PasswordChangeMeModel } from '../models/password-change-me.model';
import { PaginationModel } from '../models/pagination.model';
import { CreditCardModel } from '../models/credit-card.model';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService<UserModel> {

  tipo: string;
  urlBase: string;
  constructor(protected httpClient: HttpClient, private authService: NbAuthService) {
    super(httpClient);

    this.tipo = `Usuario`;
    this.urlBase = `${environment.baseApi}${environment.endPoints.users.users}`;
  }

  login(mail: string, pass: string): Observable<NbAuthResult> {
    return this.authService.authenticate('email', { email: mail, password: pass });
  }

  findMe(): Observable<UserModel> {
    const op = 'Obtención usuario actual';
    return this.httpClient.get<UserModel>(`${this.urlBase}${environment.endPoints.users.me}`);
  }

  logOut(): Observable<NbAuthResult> {
    const retval: Observable<NbAuthResult> = this.authService.logout('email');
    localStorage.removeItem('auth_app_token');
    return retval;
  }

  restorePassword(email: string): Observable<ResposeInfoModel> {
    return this.httpClient.post<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.restorePassword}`, { email: email });
  }

  updatePassword(email: string, codigoEmail: string, password: string): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.updatePassword}`,
      {
        email: email,
        codigo_email: codigoEmail,
        password: password
      });
  }

  updateMePassword(_id: string, passwords: PasswordChangeMeModel): Observable<PasswordChangeMeModel> {
    return this.httpClient.put<PasswordChangeMeModel>(`${this.urlBase}/${_id}${environment.endPoints.users.updateMePassword}`, passwords);
  }

  saveCreditCard(creditCard: CreditCardModel): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.creditcard}/add`, creditCard);
  }

  removeCreditCard(): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.creditcard}/remove`, null);
  }

  existCreditCard(): Observable<ResposeInfoModel> {
    return this.httpClient.get<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.creditcard}/exist`);
  }

  // Actualizo un usuario
  updateMe(usuario: UserModel): Observable<UserModel> { // entre parentesis son los parametros y el observable es el tipo al que te subscribes
    return this.httpClient.put<UserModel>(`${this.urlBase}${environment.endPoints.users.me}`, usuario);
  }

  approveUser(_id: string): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.approve}/${_id}`, '');
  }

  denyUser(_id: string): Observable<ResposeInfoModel> {
    return this.httpClient.put<ResposeInfoModel>(`${this.urlBase}${environment.endPoints.users.deny}/${_id}`, '');
  }

  userLogged(): boolean {
    let result = false;
    this.authService.isAuthenticated()
      .subscribe((resultado) => result = resultado);

    return result;
  }

  /**
   * Obtenemos los roles que tiene el usuario actualmente para la securidad de las rutas.
   * @returns {Observable<string[]>}
   * @memberof UserService
   */
  getRole(): Observable<string[]> {
    const roles: string[] = [];
    return this.authService.onTokenChange()
      .pipe(
        map((token: NbAuthJWTToken) => {
          if (token.isValid()) {
            // tslint:disable-next-line: no-string-literal
            const userRoles: RolModel[] = token.getPayload()['roles'];
            userRoles.forEach((rol) => roles.push(rol.nombre));
          } else {
            roles.push('guest');
          }
          return roles;
        })
      );
  }

  search(usuarioBusqueda: UserModel, page: number): Observable<PaginationModel> {
    const params = this.gerenerateParamSearch(usuarioBusqueda, page);
    return this.httpClient.get<PaginationModel>(`${this.urlBase}${environment.endPoints.users.busqueda}?${params}`);
  }

  private gerenerateParamSearch(usuarioBusqueda: UserModel, page: number): string {
    let params = `page=${page}&size=${environment.max_size_page_tables}&sortDirection=-1&sortField=nombre`;

    if (usuarioBusqueda.nombre) {
      params += `&nombre=${usuarioBusqueda.nombre}`;
    }
    if (usuarioBusqueda.apellido) {
      params += `&apellido=${usuarioBusqueda.apellido}`;

    }
    if (usuarioBusqueda.nif) {
      params += `&nif=${usuarioBusqueda.nif}`;
    }
    if (usuarioBusqueda.email) {
      params += `&email=${usuarioBusqueda.email}`;
    }
    if (usuarioBusqueda.usuario) {
      params += `&usuario=${usuarioBusqueda.usuario}`;
    }
    if (usuarioBusqueda.telefono) {
      params += `&telefono=${usuarioBusqueda.telefono}`;
    }

    return params;

  }
}
